import React from 'react';

import { ButtonSelect } from '@ubisend/pulse-components';
import { useTemplating } from '@ubisend/pulse-templating';

import composers from '../../../Types/index';

const composersWithSnippets = composers.filter(composer => {
  return Boolean(composer.snippet);
});

const AddComposerTag = () => {
  const templating = useTemplating();

  const handleAddForTag = ({ value }) => {
    templating.dispatch({ type: templating.TYPES.ADD_SNIPPET, snippet: value });
  };

  const format = composer => {
    return {
      label: composer.name,
      value: composer.snippet
    };
  };

  return (
    <ButtonSelect
      onChange={handleAddForTag}
      value={null}
      options={composersWithSnippets.map(format)}
      placeholder="Add composer..."
    />
  );
};

export default AddComposerTag;
